var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { sendVoiceCode } from '@/views/login/api/auth';
import { Vue, Component } from 'vue-property-decorator';
var VoiceModal = /** @class */ (function (_super) {
    __extends(VoiceModal, _super);
    function VoiceModal() {
        // @Prop({
        //   type: String,
        //   default: '',
        // }) private mobile?: string // 手机号
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.dialogVisible = false;
        _this.mobile = '';
        return _this;
    }
    VoiceModal.prototype.open = function (mobile) {
        this.mobile = mobile;
        this.dialogVisible = true;
    };
    VoiceModal.prototype.close = function () {
        this.dialogVisible = false;
    };
    /**
   * @description 手机号第3位、第7位后加空格
   * @param str 输入的手机号
   * @return 加空格后的字符串
   */
    VoiceModal.prototype.formattedMobile = function (str) {
        if (typeof str !== 'string')
            return '';
        var numStr = str.trim();
        if (!/^\d+$/.test(numStr))
            return '';
        var front = numStr.length >= 3 ? numStr.slice(0, 3) : numStr;
        var center = numStr.length >= 7 ? numStr.slice(3, 7) : numStr.slice(front.length);
        var end = numStr.slice(3 + center.length);
        return [front, center, end].join(' ');
    };
    VoiceModal.prototype.submit = function () {
        var _this = this;
        try {
            // 发送验证码的逻辑
            sendVoiceCode({ mobile: this.mobile }).then(function () {
                _this.close();
            });
        }
        catch (error) {
            this.$toast('请重试');
        }
    };
    VoiceModal = __decorate([
        Component({
            components: {},
        })
    ], VoiceModal);
    return VoiceModal;
}(Vue));
export default VoiceModal;
